import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="email-gate"
//
// Email-first, progressive sign-in (Amazon/Google style):
//   step 1 — collect the email and "Continue"
//   step 2 — reveal the ways in (passkey / password / magic link), all reusing
//            the one email already typed. We deliberately never ask the server
//            whether the email exists, so this stays a pure client-side toggle
//            with no enumeration oracle.
//
// Targets:
//   step1/step2  — the two panels
//   email        — the single canonical email input (lives in step 1)
//   emailLabel   — read-only echo of the email shown in step 2
//   passwordEmail/magicEmail — hidden user[email] fields inside each form
//   passkeyEmail — hidden input feeding the passkey ceremony's email scope
//   password     — focused when step 2 opens
// Values:
//   advanced — true when the server re-rendered with an error, so we open
//              straight to step 2 with the email kept.
export default class extends Controller {
  static targets = [
    "step1",
    "step2",
    "email",
    "emailLabel",
    "passwordEmail",
    "magicEmail",
    "passkeyEmail",
    "password",
  ];
  static values = { advanced: Boolean };

  connect() {
    if (this.advancedValue && this.emailTarget.value.trim()) {
      this.reveal({ focusPassword: false });
    }
  }

  continue(event) {
    if (event) event.preventDefault();
    if (!this.emailTarget.checkValidity()) {
      this.emailTarget.reportValidity();
      return;
    }
    this.reveal({ focusPassword: true });
  }

  edit(event) {
    if (event) event.preventDefault();
    this.step2Target.hidden = true;
    this.step1Target.hidden = false;
    this.emailTarget.focus();
    this.emailTarget.select();
  }

  reveal({ focusPassword }) {
    const email = this.emailTarget.value.trim();
    if (this.hasPasswordEmailTarget) this.passwordEmailTarget.value = email;
    if (this.hasMagicEmailTarget) this.magicEmailTarget.value = email;
    if (this.hasPasskeyEmailTarget) this.passkeyEmailTarget.value = email;
    if (this.hasEmailLabelTarget) this.emailLabelTarget.textContent = email;

    this.step1Target.hidden = true;
    this.step2Target.hidden = false;
    if (focusPassword && this.hasPasswordTarget) this.passwordTarget.focus();
  }
}
